import { z } from 'zod';
export const SUPPORTED_LOCALES = ['ru', 'en', 'kk'];
export const DEFAULT_LOCALE = 'ru';
export const INTL_LOCALES = {
    ru: 'ru-RU',
    en: 'en-US',
    kk: 'kk-KZ',
};
export const localeSchema = z.enum(SUPPORTED_LOCALES);
export function normalizeLocale(input) {
    if (!input)
        return DEFAULT_LOCALE;
    const lower = input.toLowerCase().split(/[-_]/)[0];
    return SUPPORTED_LOCALES.includes(lower) ? lower : DEFAULT_LOCALE;
}
export function toIntlLocale(locale) {
    return INTL_LOCALES[normalizeLocale(locale)];
}
//# sourceMappingURL=locale.js.map